import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { objectToQueryString } from '../../../../utils/queryHelper';
import { MarketplaceBroker } from '../models/broker';

export const GetBroker = createAsyncThunk(
    'marketplaceBrokers/getBroker',
    async (brokerId: number | null, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.get(
                `/api/Marketplace/MarketplaceBrokers?${objectToQueryString({
                    brokerId: brokerId,
                })}`
            );

            if (response.status !== 200) {
                createNotification(
                    'Could not fetch profile at the moment.',
                    'error'
                );
                throw new Error('Failed to fetch profile');
            }

            return {
                broker: response.data as MarketplaceBroker,
            };
        } catch (error) {
            createNotification(
                'An error occurred while fetching profile.',
                'error'
            );
            throw error;
        }
    }
);
